module.exports = __webpack_public_path__ + "static/media/45.4f8932e5.jpg";